<template>
  <div
    class="relative w-full h-full"
    :class="
      currentContract.id || currentPolls.length > 0 || subaccountContract.id
        ? 'overflow-hidden'
        : 'overflow-auto'
    "
    ref="scroller"
  >
    <div
      v-if="toast"
      @click="toast = false"
      class="rounded-lg text-white font-bold px-6 py-3 max-w-96 fixed bottom-5 right-5 z-50 transition-transform transform translate-y-0"
      :class="
        toastStatus == 'success'
          ? 'bg-green-600'
          : toastStatus == 'warning'
          ? 'bg-orange-300'
          : 'bg-red-500'
      "
    >
      {{ toast }}
    </div>
    <div
      v-if="subaccountContract.id"
      class="absolute w-full h-full text-center top-0 left-0 bg-black/50"
    >
      <div class="bg-white rounded-lg p-4 lg:w-1/2 mx-3 mt-2 text-left inline-block">
        <font-awesome-icon
          icon="xmark"
          class="text-3xl text-primary cursor-pointer float-right m-3"
          @click="subaccountContract = {}"
        />
        <span class="text-2xl font-bold">{{$t('Unteraccount verwalten')}}</span><br />
        <span class="mb-4 inline-block"
          >{{$t('Hier können Sie die E-Mail-Adresse für den Unteraccount festlegen. Der Unteraccount kann keine Daten ändern, sondern nur Essensbuchungen vornehmen und die Mensa-Karte anzeigen.')}}
          </span
        >
        <label>{{$t('E-Mail')}}</label>
        <input v-model="subaccountContract.Unteraccount" placeholder="E-Mail" />
        <div class="w-full text-left mt-3">
          <button class="full" @click="updateSubaccount()">{{$t('Speichern')}}</button>
        </div>
      </div>
    </div>
    <BookingPopup
      v-if="currentContract.id"
      :currentContract="currentContract"
      :readonly="true"
      @toast="showToast"
      :user="user"
      @close="currentContract = {}"
    />
    <PollPopup
      v-if="currentPolls.length > 0"
      :polls="currentPolls"
      :contract="pollContract"
      @toast="showToast"
      @close="currentPolls = [];window.history.pushState(null, null, '/services')"
    />
    <div
      v-if="loading"
      class="flex items-center justify-center h-64"
    >
      <div class="text-center">
        <div class="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-primary mb-4"></div>
        <p class="text-gray-600">{{$t('Leistungen werden geladen...')}}</p>
      </div>
    </div>
    <div
      v-else-if="contracts.length == 0"
      class="font-bold m-4 p-4 rounded-lg bg-white"
    >
      <span>{{$t('Sie haben noch keine Leistungen gebucht.')}} <a href="/book" class="text-primary underline">{{$t('Buchen Sie Ihre erste Leistung')}}</a>.</span>
    </div>
    <div v-else-if="!loading" class="p-4">
      <div
        v-for="contract in contracts"
        :key="contract"
        class="bg-white rounded-lg p-4 mb-4 mr-4 border-primary border inline-block align-top cursor-pointer w-88 md:w-96 shadow-lg"
        :class="{ '!bg-gray-200': !contract.active }"
      >
        <span class="font-bold text-lg h-14 inline-block">{{ contract.Titel }}</span>
        <div class="">
          <div>
            <span
              ><b>{{$t('Status')}}: </b
              ><span
                class="font-bold"
                :class="{
                  'text-red-500': ['Gekündigt','Widerrufen','Absage','Ausgelaufen'].includes(contract.Status),
                  'text-green-500': ['Bestätigt'].includes(contract.Status),
                  'text-yellow-500': [
                    'Eingegangen',
                    'Warteliste',
                    'Vorgemerkt',
                    'Kündigung eingegangen',
                  ].includes(contract.Status),
                }"
                >{{ contract.Status }}</span
              ></span
            ><br />
            <span><b>{{$t('Kind')}}: </b>{{ contract.Vorname }}</span
            ><br />
            <span><b>{{$t('Start')}}: </b>{{ contract.Vertragsbeginn }}</span
            ><br />
            <span v-if="contract.Vertragsende"
              ><b>{{$t('Ende')}}:</b> {{ contract.Vertragsende }}</span
            >
            <span v-else><b>{{$t('Ende')}}:</b> Offen</span>
            <div class="float-right text-right pt-4">
              <button
                v-if="
                  ['Bestätigt', 'Gekündigt'].includes(contract.Status) &&
                  contract.poll
                "
                class=""
                @click="
                  scrollToTop(() => {
                    viewPoll(contract);
                  })
                "
              >
                {{$t('Umfrage beantworten')}}
              </button>
              <button
                class=""
                @click="
                  scrollToTop(() => {
                    selectContract(contract);
                  })
                "
              >
                {{$t('Details')}}
              </button>
              <button
                v-if="
                  ['Bestätigt', 'Gekündigt'].includes(contract.Status) &&
                  contract.subaccount
                "
                @click="
                  scrollToTop(() => {
                    subaccountContract = contract;
                  })
                "
              >
                Unteraccount
              </button>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
label {
  display: block;
  font-weight: bold;
}
table {
  max-width: 100%;
  border-collapse: collapse;
}

th,
td {
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

tr:nth-child(even) {
  background-color: #e6e6e6;
  /* Set the background color for even rows */
}
</style>
<script>
// @ is an alias to /src
import API from "@/API";
import BookingPopup from "@/components/BookingPopup.vue";
import PollPopup from "@/components/PollPopup.vue";
export default {
  name: "Mealplanning",
  props: ["user"],

  data() {
    return {
      toast: "",
      toastStatus: false,
      customerdata: {},
      contracts: [],
      loading: true,
      currentContract: {},
      currentPolls: [],
      newContract: {},
      pollContract: {},
      subaccountContract: {},
      window:window
    };
  },
  components: {
    PollPopup,
    BookingPopup,
  },
  methods: {
    scrollToTop(runAfter) {
      this.$refs.scroller.scrollTo({ top: 0, behavior: "smooth" });
      setTimeout(runAfter, 500);
    },
    getCustomerData() {
      API.getCustomerData((r, status) => {
        if (status === 200) {
          this.customerdata = r;
        }
      });
    },
    updateSubaccount() {
      // Check if the entered email matches parent emails
      const enteredEmail = this.subaccountContract.Unteraccount?.toLowerCase();
      
      if (enteredEmail === this.user.user?.toLowerCase()) {
        this.showToast("Die eingegebene E-Mail-Adresse darf nicht mit Ihrer eigenen E-Mail-Adresse übereinstimmen.", "warning");
        return;
      }
      
      API.updateContract(this.subaccountContract, (r, status) => {
        if (status === 200) {
          this.showToast("Unterkonto aktualisiert");
          this.getContracts();
          this.subaccountContract = {};
        } else if (r.error) {
          this.showToast(r.error, false);
        } else {
          this.showToast("Unterkonto konnte nicht aktualisiert werden", false);
        }
      });
    },
    getContracts() {
      this.loading = true;
      API.getContracts((r, status) => {
        if (status === 200) {
          this.contracts = r;
          if(this.$route.query.pollContract){
            this.viewPoll(this.contracts.find(c => c.id == this.$route.query.pollContract));
          }
        }
        this.loading = false;
      });
    },
    selectContract(contract) {
      this.currentContract = contract;
    },
    viewPoll(contract) {
      this.pollContract = contract;
      window.history.pushState(null, null, '/services?pollContract=' + contract.id);
      API.getPollsForContract(contract.id, (r, status) => {
        if (status === 200) {
          this.currentPolls = r;
        }
      });
    },
    handlePollIdQuery(pollId) {
      API.getPollByPollId(pollId, (r, status) => {
        if (status === 200) {
          // Poll found and user has access
          if (r.contracts && r.contracts.length > 0) {
            // Use the first contract to view the poll
            const contract = this.contracts.find(c => c.id === r.contracts[0].id);
            if (contract) {
              this.viewPoll(contract);
            } else {
              // Contract not loaded yet, wait for contracts to load
              const checkContracts = setInterval(() => {
                const foundContract = this.contracts.find(c => c.id === r.contracts[0].id);
                if (foundContract) {
                  clearInterval(checkContracts);
                  this.viewPoll(foundContract);
                }
              }, 100);
              // Clear interval after 5 seconds if contract not found
              setTimeout(() => clearInterval(checkContracts), 5000);
            }
          }
        } else if (status === 404) {
          this.showToast(r.error || "Umfrage nicht gefunden oder Sie haben keinen Zugriff", "warning");
        } else {
          this.showToast("Fehler beim Laden der Umfrage", false);
        }
      });
    },
    showToast(msg, status = "success") {
      this.toast = msg;
      this.toastStatus = status;
      if (this.toastTimer) {
        clearTimeout(this.toastTimer);
      }
      this.toastTimer = setTimeout(() => {
        this.toast = "";
      }, 10000);
    },
  },
  created() {
    this.getCustomerData();
    this.getContracts();
    
    // Handle pollId query parameter
    if (this.$route.query.pollId) {
      this.handlePollIdQuery(this.$route.query.pollId);
    }
  },
};
</script>